
export function EstimateTextareaHeight(value: string) {
    let lineCount = (value.match(/\n/g) || '').length + 1;
    let linesHeight = Math.max(1.6*lineCount+1, 5);
    return linesHeight + 'em';
}
